import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { Table, TableRow, TableCol } from '../../../../../components/pdf/Table'
import { TableHeadText } from '../../../../../components/pdf/TableHelpers'

const SignatureSection = () => {
  return (
    <View id="7" pageBreakAfter>
      <Text bold size="small">
        7 ASSINATURA
      </Text>

      <Table width="75%" center>
        <TableRow>
          <TableHeadText colSpan={2} align="center">
            Responsável Revisão Técnica do Documento:
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableCol style={{ width: '50%' }}>
            <Text size="small">Engenheiro de Segurança do Trabalho</Text>
            <Text size="small">Bruno D’Attilio</Text>
            <Text size="small">CREA: 12345678</Text>
          </TableCol>
          <TableCol>
            <Text size="small">
              Este documento foi assinado com certificado digital (última página), emitido pela ICP-Brasil, através de
              chaves criptográficas.
            </Text>
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={8} />
    </View>
  )
}

export default SignatureSection
